<template>
  <div class="page flex-col" :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <top-bar />
    <img class="logo" alt="" referrerpolicy="no-referrer" :src="meta.logo"/>
    <div class="list_1 flex-col">
      <div class="list-items_1 flex-row" @click="navPreview(item.petId)"
        v-for="(item, index) in petList" :key="index">
        <div class="block_2 flex-col" :style="item.petImage"></div>
        <div class="text-group_1 flex-col justify-center">
          <span class="text_2">{{ item.petNickname }}</span>
        </div>
        <div class="btn-container flex-row justify-between">
          <button class="unbind" @click.stop="unbind(item.generatedId)"/>
          <button class="edit" @click.stop="navEdit(item.petId)"/>
        </div>
      </div>
    </div>
    <div class="add-btn flex-col" @click="navAdd">
      <span class="text_4">{{ $t('person_list["Add a New Profile"]') }}</span>
    </div>

    <custom-dialog
      v-for="(dialog,i) in dialogs" :key="i"
      v-model="dialog.show"
      :confirmText="dialog.confirmText"
      :confirmBtnLoading="dialog.confirmBtnLoading"
      @confirm="dialog.confirm"
      :title="dialog.title"
      :info="dialog.content"
    />

  </div>
</template>
<script>
import meta from "../../utils/meta";
import axios from "../../utils/request"

export default {
  data() {
    return {
      petList: [],
      dialogs: [{
        show: false,
        title: this.$t('person_list["unbind title"]'),
        confirmText: this.$t('base.ok'),
        content: this.$t('person_list["unbind info"]'),
        confirmBtnLoading: false,
        confirm: this.ajaxDoUnbind
      }],
      unbindTagId: '',
      meta
    };
  },
  created() {
    this.fetchPetList()
  },
  methods: {
    // 解绑宠物
    unbind(generatedId) {
      this.unbindTagId = generatedId
      this.dialogs[0].show = true
    },
    ajaxDoUnbind() {
      if (!this.unbindTagId) {
        this.dialogs[0].show = false
        return
      }
      this.dialogs[0].confirmBtnLoading = true
      axios({
        url: '/businese/dog_tag/unbindTag?id=' + this.unbindTagId,
      }).then(({ code, msg }) => {
        if (code === 200) {
          this.fetchPetList()
        }
        this.dialogs[0].show = false
      }).finally(() => this.dialogs[0].confirmBtnLoading = false)
    },
    // 路由到编辑宠物页面
    navEdit(petId) {
      this.$router.push('/edit_info/pet/' + petId)
    },
    // 路由到新增宠物页面
    navAdd() {
      this.$router.push('/edit_info/pet/0')
    },
    // 路由到预览宠物信息页面
    navPreview(petId) {
      this.$router.push('/checked_info/' + petId)
    },
    // 获取宠物列表
    fetchPetList() {
      axios('/businese/dog_tag/listPets')
        .then(({ code, data, msg }) => {
          if (code === 200) {
            // 用户刚注册，绑定了一个狗牌编码但还没有绑定宠物，
            // 此时该接口返回这个狗牌编码
            // 导航到新增宠物页面，并且不将当前页面保存在浏览历史中
            if ('string' === typeof data) {
              this.$router.replace('/edit_info/pet/0?generatedId=' + data)
              return
            }
            // 用户没有任何宠物数据，导航到新增宠物页面
            // 并且不将当前页面保存在浏览历史中
            if (Array.isArray(data) && !data.length) {
              this.$router.replace('/edit_info/pet/0')
              return
            }
            this.petList = data.map(pet => {
              pet.petImage = {
                backgroundImage: `url(${pet.petImage})`
              }
              return pet
            })
            return
          }
          this.$message.error(msg || this.$t('person_list["Fetch list failed."]'))
        })
    }
  },
};
</script>
<style src="@/assets/common.css" scoped />
<style src="./index.css" scoped />



// WEBPACK FOOTER //
// src/views/person_list/index1.vue